import API from "../Utils/Api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// return the token from the session storage
export const getToken = () => {
  return localStorage.getItem("token") || null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("business_id");
  localStorage.removeItem("token_expiry");
  localStorage.removeItem("location_id");
  localStorage.removeItem("location_town");
  localStorage.removeItem("location");
  localStorage.removeItem("location_without_login_id");
  localStorage.removeItem("location_without_login");
  localStorage.removeItem("is_profile_verify");
  localStorage.removeItem("is_profile_verify_buss");
  localStorage.removeItem("cur_location");
};

// set the token and user from the session storage
export const setUserSession = (token, role) => {
  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
  const expiryHours = 1;
  const now = new Date();
  const expiryTime = now.getTime() + expiryHours * 60 * 60 * 1000;
  localStorage.setItem("token_expiry", expiryTime.toString());
};

export const getBaseurl = () => {
  //const BASE_URL = "http://localhost:3000/";
  //const BASE_URL = "http://192.168.0.123:3000/";
  const BASE_URL = 'https://localbells.com/';
  //const BASE_URL = 'https://localbells.jditechnology.net/';
  return BASE_URL;
};
export const getUserDetails = (token) => {
  let formData = new FormData();
  formData.append("token", token);
  API.post("get_profile", formData)
    .then((response) => {
      console.log(response);
      if (response.data.status === 0) {
      } else {
      }
    })
    .catch((error) => {});
};
export const gettoastwarning = (message, url_link) => {
  toast.warning(message, {
    bodyClassName: "custom-toast-body",
    toastClassName: "custom-toast",
    position: "top-center",
    autoClose: 3000,
    onClose: () => {
      if (url_link !== "") {
        window.location.href = url_link;
      }
    },
    style: {
      width: "320px", // Set the desired width
      marginTop: "5px", // Set the desired top margin
    },
    bodyStyle: {
      marginTop: "20px", // Set the desired margin for the text content
      marginBottom: "20px", // Set the desired margin for the text content
    },
  });
};
export const gettoastsuccess = (message, url_link) => {
  toast.success(message, {
    bodyClassName: "custom-toast-body",
    toastClassName: "custom-toast",
    position: "top-center",
    autoClose: 3000,
    onClose: () => {
      if (url_link !== "") {
        window.location.href = url_link;
      }
    },
    style: {
      width: "320px", // Set the desired width
      marginTop: "5px", // Set the desired top margin
    },
    bodyStyle: {
      marginTop: "20px", // Set the desired margin for the text content
      marginBottom: "20px", // Set the desired margin for the text content
    },
  });
};
